import React from 'react';
import Payouts from '../../components/AdminNext/Payouts';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };
  return {
    title: 'Payouts — Bas Recovery Admin',
    component: <HeadLessLayout><Payouts /></HeadLessLayout>
  };
}

export default action;
